var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as PIXI from 'pixi.js';
import { FontAtlasTextGeometry, LEFT, RIGHT } from "./fontAtlasTextGeometry";
import { CARET_POSITION } from "./fontAtlasTextCaret";
import { MeshMixin } from "./meshMixin";
import { DeformerStack } from "./deformers/deformerStack";
import { AnimationStack } from "./animation/animationStack";
var VERBOSE = false;
// TODO: Look at PIXI.Mesh. This object has all the necessary properties to enable rendering
var FontAtlasText = /** @class */ (function (_super) {
    __extends(FontAtlasText, _super);
    function FontAtlasText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // TODO: make into a property
        //  is this the same as tint?
        _this._color = [1.0, 0.0, 0.0, 1.0];
        _this._text = 'hello world!';
        _this._dirty = true; // should use PIXI update properties so as _transformID, see Mesh
        _this.maxWidth = 512;
        _this.maxHeight = 512;
        _this._atlas = undefined;
        _this._fontSize = 12;
        _this._lineHeight = 1;
        _this._fontFactor = 1;
        _this._tokenIndex = 0;
        _this._tokens = [];
        _this._lines = [];
        _this._words = [];
        // TODO: rename to GeometryBuilder instead?
        _this._fontAtlasTextGeometry = new FontAtlasTextGeometry();
        return _this;
    }
    Object.defineProperty(FontAtlasText.prototype, "deform", {
        get: function () {
            return this._deformerStack;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasText.prototype, "anim", {
        get: function () {
            return this._animationStack;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasText.prototype, "atlas", {
        get: function () {
            return this._atlas;
        },
        set: function (atlas) {
            var _this = this;
            VERBOSE && console.log('set atlas', atlas);
            this._atlas = atlas;
            this._fontAtlasTextGeometry.atlasResolution = atlas.resolution;
            this._deformerStack = new DeformerStack(this, { uvs: true });
            this._animationStack = new AnimationStack(this);
            // NOTE: we should probably set this up during construction
            // TODO: Do we still need this? This should just run during update no?
            // @ts-ignore
            this._deformerStack.on('deformerAdded', function () {
                VERBOSE && console.log('deformer added');
                _this._buildShader();
            });
            // @ts-ignore
            this._deformerStack.on('deformerChanged', function () {
                VERBOSE && console.log('deformer changed');
                _this._buildShader();
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasText.prototype, "glyph", {
        get: function () {
            return this._fontAtlasTextGeometry._glyph;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasText.prototype, "text", {
        get: function () {
            return this._text;
        },
        set: function (value) {
            if (value === this.text) {
                return;
            }
            this._text = value;
            this._dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasText.prototype, "fontSize", {
        get: function () {
            return this._fontSize;
        },
        set: function (value) {
            if (value === this.fontSize) {
                VERBOSE && console.log("fontSize not changed: ".concat(value));
                return;
            }
            VERBOSE && console.log('set fontSize', value);
            this._fontSize = value;
            this._dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasText.prototype, "lineHeight", {
        // TODO: adding wordSpacing
        get: function () {
            return this._lineHeight;
        },
        set: function (value) {
            if (value === this.lineHeight) {
                return;
            }
            this._lineHeight = value;
            this._dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    // @deprecated
    FontAtlasText.prototype._setUniform = function (property, value) {
        if (!this._shader) {
            return;
        }
        this._shader.uniforms[property] = value;
    };
    /**
     * The font atlas size can be different from this font size. Therefore, we have to come up with a value by which
     * we need to multiply our atlas font glyphs to get the requested font size.
     */
    FontAtlasText.prototype._calculateFontFactor = function () {
        if (!this.atlas) {
            return;
        }
        this._fontFactor = this.fontSize / this.atlas.fontSize;
    };
    Object.defineProperty(FontAtlasText.prototype, "glyphCount", {
        get: function () {
            return this._fontAtlasTextGeometry.glyphCount;
        },
        enumerable: false,
        configurable: true
    });
    FontAtlasText.prototype.getGlyphVertexArray = function (index) {
        return this._fontAtlasTextGeometry._getGlyphVertexArray(index);
    };
    FontAtlasText.prototype.getGlyphCenter = function (index) {
        return this._fontAtlasTextGeometry.getGlyphCenter(index);
    };
    FontAtlasText.prototype.containsGlyph = function (x, y) {
        // TODO: refactor to use deformer stack
        // if (this._curveData) {
        //     ({x, y} = this._curveData.invertPosition(x, y));
        // }
        var glyphCount = this._fontAtlasTextGeometry._glyph.length - 1;
        return this._fontAtlasTextGeometry.containsGlyph(x, y, { start: 0, end: glyphCount });
    };
    FontAtlasText.prototype.closestGlyph = function (x, y) {
        // TODO: refactor to use deformer stack
        // if (this._curveData) {
        //     ({x, y} = this._curveData.invertPosition(x, y));
        // }
        var glyphCount = this._fontAtlasTextGeometry._glyph.length - 1;
        return this._fontAtlasTextGeometry.closestGlyph(x, y, { start: 0, end: glyphCount });
    };
    FontAtlasText.prototype.closestWord = function (x, y) {
        // TODO: refactor to use deformer stack
        // if (this._curveData) {
        //     ({x, y} = this._curveData.invertPosition(x, y));
        // }
        var _a = this.closestGlyph(x, y), index = _a[0], _ = _a[1];
        return this.glyphWordIndex(index);
    };
    FontAtlasText.prototype.closestLine = function (x, y) {
        // TODO: refactor to use deformer stack
        // if (this._curveData) {
        //     ({x, y} = this._curveData.invertPosition(x, y));
        // }
        var _a = this.closestGlyph(x, y), index = _a[0], _ = _a[1];
        return this.glyphLineIndex(index);
    };
    FontAtlasText.prototype.closestGlyphWithinRange = function (x, y, glyphRange) {
        return this._fontAtlasTextGeometry.closestGlyph(x, y, glyphRange);
    };
    FontAtlasText.prototype.getClosestGlyphOnLine = function (glyphIndex, lineIndex) {
        var _a = this._getLineGlyphRange(lineIndex), start = _a[0], end = _a[1];
        var glyphCenter = this.getGlyphCenter(glyphIndex);
        var result = this.closestGlyphWithinRange(glyphCenter.x, glyphCenter.y, { start: start, end: end });
        return result;
    };
    FontAtlasText.prototype.getGlyphBefore = function (index, position) {
        if (index === 0) {
            return [0, CARET_POSITION.START];
        }
        var indexBefore = index - 1;
        if (this.lastGlyphIndex < indexBefore) {
            return [this.lastGlyphIndex, position];
        }
        return [indexBefore, position];
    };
    FontAtlasText.prototype.getGlyphAfter = function (index, position) {
        if (index === this.lastGlyphIndex && position === LEFT) {
            return [index, RIGHT];
        }
        var nextIndex = index + 1;
        var nextToken = this.text[nextIndex];
        // @ts-ignore
        if (PIXI.TextMetrics.isNewline(nextToken) && position === LEFT) {
            return [index, RIGHT];
        }
        if (this.lastGlyphIndex < nextIndex) {
            return [this.lastGlyphIndex, position];
        }
        return [nextIndex, position];
    };
    FontAtlasText.prototype.getGlyphAbove = function (index) {
        if (index === 0) {
            return [0, LEFT];
        }
        var glyphLineIndex = this.glyphLineIndex(index);
        // if the glyph is on the first line
        if (!glyphLineIndex) {
            return [index, LEFT];
        }
        // get the closest glyph on the previous line
        var prevLineIndex = glyphLineIndex - 1;
        var _a = this.getClosestGlyphOnLine(index, prevLineIndex), indexAbove = _a[0], _ = _a[1];
        if (indexAbove === index) {
            return [indexAbove, LEFT];
        }
        // @ts-ignore
        if (PIXI.TextMetrics.isNewline(this.text[indexAbove])) {
            return [indexAbove, RIGHT];
        }
        return [indexAbove, LEFT];
    };
    FontAtlasText.prototype.getGlyphBelow = function (index) {
        var glyphLineIndex = this.glyphLineIndex(index);
        if (glyphLineIndex === this.lastGlyphLineIndex) {
            // @ts-ignore
            if (PIXI.TextMetrics.isNewline(this.text[this.lastGlyphIndex])) {
                return [this.lastGlyphIndex, RIGHT];
            }
            return [index, LEFT];
        }
        var nextLineIndex = glyphLineIndex + 1;
        var _a = this.getClosestGlyphOnLine(index, nextLineIndex), indexBelow = _a[0], _ = _a[1];
        if (indexBelow === index) {
            if (indexBelow + 1 > this.lastGlyphIndex) {
                return [indexBelow, LEFT];
            }
            else {
                indexBelow += 1;
                return [indexBelow, RIGHT];
            }
        }
        return [indexBelow, LEFT];
    };
    FontAtlasText.prototype.glyphWordIndex = function (index) {
        return this.words.findIndex(function (word) { return word.indexOf(index) !== -1; });
    };
    FontAtlasText.prototype.glyphLineIndex = function (index) {
        for (var i = 0; i < this.lines.length; i++) {
            var _a = this._getLineGlyphRange(i), start = _a[0], end = _a[1];
            if (index >= start && index <= end) {
                return i;
                break;
            }
        }
        return -1;
    };
    Object.defineProperty(FontAtlasText.prototype, "lastGlyphIndex", {
        get: function () {
            return this.glyph.length - 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasText.prototype, "lastGlyphLineIndex", {
        get: function () {
            return this._lines.length - 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasText.prototype, "lines", {
        get: function () {
            return this._lines;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasText.prototype, "words", {
        get: function () {
            return this._words;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasText.prototype, "dirty", {
        /**
         * Determines if the text is dirty and needs any of its elements to be rebuilt. This includes the text,
         * deformation stack and animation. Note to be confused with _dirty.
         */
        get: function () {
            if (this.anim.dirty) {
                return true;
            }
            if (this.deform.dirty) {
                return true;
            }
            return this._dirty;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Here we update the internal state. We don't really build any new objects which the caller can interact with
     * separately.
     */
    FontAtlasText.prototype._update = function () {
        VERBOSE && console.log('text build', this.dirty);
        if (!this._dirty && !this.deform.dirty && !this.anim.dirty) {
            // it's important that we keep evaluating this while the text hasn't been fully updated.
            // this will allow us to easily determine whether everything is up-to-date.
            VERBOSE && console.log('nothing to do');
            return;
        }
        if (!this.atlas.loaded) {
            VERBOSE && console.log('unable to build text, atlas not loaded');
            return;
        }
        if (this._dirty) {
            this._calculateFontFactor();
            this._deleteGeometry();
            this._buildGlyphs();
            this._layoutGlyphs();
            this._buildGeometry();
            this._buildShader();
        }
        if (this.deform.dirty) {
            this.deform.update();
            this._buildShader();
        }
        if (this.anim.dirty) {
            this.anim.update();
        }
        this._dirty = false;
    };
    FontAtlasText.prototype._buildGlyphs = function () {
        var _this = this;
        this._tokens = [];
        this._lines = [];
        this._words = [];
        this._tokenIndex = 0;
        // @ts-ignore
        var tokens = PIXI.TextMetrics.tokenize(this.text);
        tokens.forEach(function (token) {
            // @ts-ignore
            if (PIXI.TextMetrics.isBreakingSpace(token)) {
                _this._addWhitespace(token);
                return;
            }
            // @ts-ignore
            if (PIXI.TextMetrics.isNewline(token)) {
                _this._addWhitespace(token);
                return;
            }
            _this._addWord(token);
        });
    };
    FontAtlasText.prototype._moveGlyphs = function (glyphRange, xOffset, yOffset) {
        for (var i = glyphRange[0]; i <= glyphRange[1]; i++) {
            this._fontAtlasTextGeometry.moveGlyph(i, xOffset, yOffset);
        }
    };
    // add space or new line
    FontAtlasText.prototype._addWhitespace = function (token) {
        var width = this.atlas.wordSpacing * this._fontFactor;
        var height = this.atlas.fontSize * this._fontFactor;
        var glyphIndex = this._fontAtlasTextGeometry.addWhitespace(token, width, height);
        this._tokens.push({
            token: token,
            width: width,
            advanceHeight: height,
            glyphIndexBounds: [glyphIndex, glyphIndex],
        });
        this._tokenIndex++;
    };
    FontAtlasText.prototype._addWord = function (word) {
        var _this = this;
        this.atlas.addGlyphsForString(word);
        var glyphIds = this.atlas.getGlyphsForWord(word);
        var width = glyphIds
            .map(function (glyphId) { return _this.atlas.glyph[glyphId].advanceWidth * _this._fontFactor; })
            .reduce(function (a, b) { return a + b; });
        var advanceHeight = this.atlas.glyph[glyphIds[0]].advanceHeight * this._fontFactor;
        var xOffset = 0;
        var glyphIndexBounds = [];
        var wordIndices = [];
        glyphIds.forEach(function (id, index) {
            var metrics = _this.atlas.glyph[id];
            var glyphIndex = _this._fontAtlasTextGeometry.addGlyph(id, metrics, _this._fontFactor);
            if (index === 0) {
                glyphIndexBounds.push(glyphIndex);
            }
            if (index === glyphIds.length - 1) {
                glyphIndexBounds.push(glyphIndex);
            }
            _this._fontAtlasTextGeometry.moveGlyph(glyphIndex, xOffset, 0);
            xOffset += metrics.advanceWidth * _this._fontFactor;
            wordIndices.push(_this._tokenIndex++);
        });
        this._tokens.push({
            token: word,
            width: width,
            advanceHeight: advanceHeight,
            glyphIndexBounds: glyphIndexBounds,
        });
        this._words.push(wordIndices);
    };
    FontAtlasText.prototype._logGlyphs = function (array) {
        var _this = this;
        array.forEach(function (a, index) {
            var info = "".concat(index, " ").concat(a, ": ");
            if (a > 0) {
                info += "\"".concat(_this.glyph[a - 1].id, "\"") + '<';
            }
            info += "\"".concat(_this.glyph[a].id, "\"");
            if (_this.glyphCount - 1 > a) {
                info += '>' + "\"".concat(_this.glyph[a + 1].id, "\"");
            }
            console.log(info);
        });
    };
    FontAtlasText.prototype._layoutGlyphs = function () {
        if (this.glyphCount === 0) {
            return;
        }
        var xOffset = 0;
        var yOffset = 0;
        var lineCount = 0;
        this._lines = [];
        var lines = new Set();
        var localLineHeight = (this.atlas.fontSize * this._fontFactor) * this._lineHeight;
        // console.log('max', this.maxWidth, this.maxHeight);
        // console.log(0, `${xOffset}, ${yOffset}`, this._tokens[0]);
        for (var i = 0; i < this._tokens.length - 1; i++) {
            xOffset += this._tokens[i].width;
            // @ts-ignore
            if (xOffset + this._tokens[i + 1].width > this.maxWidth && !PIXI.TextMetrics.isNewline(this._tokens[i + 1].token) && !PIXI.TextMetrics.isBreakingSpace(this._tokens[i + 1].token)) {
                xOffset = 0;
                yOffset += localLineHeight;
                // console.log('break')
                lines.add(lineCount);
            }
            // @ts-ignore
            else if (PIXI.TextMetrics.isNewline(this._tokens[i].token)) {
                xOffset = 0;
                yOffset += localLineHeight;
                // console.log('new line')
                lines.add(lineCount);
            }
            // console.log(i + 1, `${xOffset}, ${yOffset}`, this._tokens[i + 1]);
            lineCount += this._tokens[i].token.length;
            this._moveGlyphs(this._tokens[i + 1].glyphIndexBounds, xOffset, yOffset);
        }
        lineCount += this._tokens[this._tokens.length - 1].token.length;
        // console.log('glyphCount', this.glyphCount, lineCount)
        lines.add(this.glyphCount - 1);
        this._lines = Array.from(lines);
    };
    FontAtlasText.prototype._deleteGeometry = function () {
        if (!this._geometry) {
            return;
        }
        this._fontAtlasTextGeometry.clear();
        // Question: is this expensive? We could re-use the same one...
        this._geometry.destroy();
        this._geometry = null;
    };
    Object.defineProperty(FontAtlasText.prototype, "curveData", {
        set: function (value) {
            this._curveData = value;
            this._dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    FontAtlasText.prototype._buildGeometry = function () {
        var geometry = this._fontAtlasTextGeometry.build();
        this._geometry = geometry;
    };
    Object.defineProperty(FontAtlasText.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value) {
            this._color = value;
        },
        enumerable: false,
        configurable: true
    });
    FontAtlasText.prototype._buildShader = function () {
        VERBOSE && console.log('build shader');
        var uniforms = Object.assign({
            uSampler2: this.atlas.texture[0],
            uColor: this.color,
        }, this.deform._combineUniforms());
        var vertexShader = this.deform._buildVertexShader();
        var fragmentShader = this.deform._buildFragmentShader();
        var shader = PIXI.Shader.from(vertexShader, fragmentShader, uniforms);
        this._shader = shader;
    };
    FontAtlasText.prototype.lineGlyphRanges = function () {
        var result = [];
        for (var i = 0; i < this.lines.length; i++) {
            result.push(this._getLineGlyphRange(i));
        }
        return result;
    };
    FontAtlasText.prototype._getLineGlyphRange = function (index) {
        var start = index === 0 ? 0 : this._lines[index - 1] + 1;
        var end = this._lines[index];
        return [start, end];
    };
    FontAtlasText.prototype._calculateBounds = function () {
        this._bounds.clear();
        this._bounds = this._fontAtlasTextGeometry.buildBounds();
    };
    FontAtlasText.prototype.center = function () {
        var bounds = this.getBounds();
        return {
            x: bounds.x + (bounds.width / 2),
            y: bounds.y + (bounds.height / 2)
        };
    };
    FontAtlasText.prototype._render = function (renderer) {
        VERBOSE && console.log('render');
        this._update();
        this._renderDefault(renderer);
    };
    return FontAtlasText;
}(MeshMixin(PIXI.Container)));
export { FontAtlasText };
